import { SettingOutlined } from '@ant-design/icons';
import { Button, Status } from '@mm/components';
import { useViewActions } from '@mm/state/actions/viewActions';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import dataQualityImgSrc from './data-quality-img.png';
import { ReactComponent as DataQualityTestIcon } from 'assets/data-quality-test-icon.svg';
import styles from './DataQualityTest.module.css';
import { useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../../../../../../../routes/top-level-routes';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { useDataQualityTestCRUDActions } from '@mm/state/actions/DataQualityTestCRUDActions';
import { companyFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';

export const DataQualityTest = ({
  compactView,
  className,
  hidePromo,
}: {
  compactView?: boolean;
  className?: string;
  hidePromo?: boolean;
}) => {
  const { showSlideoutMenu } = useViewActions();
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const dataQualityTest = useSelector(
    (state: StoreState) => state.dataQualityTest,
  );
  const isFeatureEnabled = useSelector(
    companyFeatureFlagsSelector,
  ).data_quality_test_enabled;
  const [busy, setBusy] = useState(false);
  const history = useHistory();
  const { getConfiguration } = useDataQualityTestCRUDActions();

  const hasConfiguration = !!Object.keys(dataQualityTest?.configuration || {})
    .length;

  const status =
    dataQualityTest?.configuration?.state === 'active'
      ? 'Running...'
      : 'Not Running';
  const statusColor =
    dataQualityTest?.configuration?.state === 'active' ? 'blue' : '#BFBFBF';

  const onGetReportClick = () => {
    history.push(Routes.dataQualityTest.getLink({ facebookPageId }));
  };

  const showDataQualitySlideout = () => {
    showSlideoutMenu('dataQualityTest');
  };

  const retriveConfig = async () => {
    setBusy(true);
    await getConfiguration(facebookPageId);
    setBusy(false);
  };

  useEffect(() => {
    if (isFeatureEnabled) {
      retriveConfig();
    }
  }, [isFeatureEnabled]);

  if (busy || !isFeatureEnabled) {
    return <></>;
  }

  if (!hasConfiguration && !hidePromo) {
    return (
      <div className={styles.dataQualityContainer}>
        <img src={dataQualityImgSrc} alt="Data Quality" />
        <div className={styles.dataQualityContent}>
          <div className={styles.dataQualityTitle}>
            <div className={styles.dataQualityTitleMain}>
              Compare pixel results with competitors
            </div>
            in a head to head live test
          </div>
          <Button
            color="secondary-blue"
            css={{ container: styles.startTestBtn }}
            onClick={showDataQualitySlideout}
          >
            Start Test
          </Button>
        </div>
      </div>
    );
  }

  return hasConfiguration ? (
    <div
      className={classNames(styles.container, className, {
        [styles.containerCompact]: compactView,
      })}
    >
      <div className={styles.titleContainer}>
        <DataQualityTestIcon />
        <div
          className={classNames(styles.title, {
            [styles.compactTitle]: compactView,
          })}
        >
          Data Quality Test
          <Status
            color={statusColor}
            status={status}
            className={classNames(styles.status, {
              [styles.leftAligned]: !compactView,
            })}
          />
        </div>
      </div>

      {dataQualityTest?.configuration?.showResult && (
        <Button css={{ container: styles.button }} onClick={onGetReportClick}>
          Check Status
        </Button>
      )}
      <Button
        color="secondary-blue"
        css={{ container: classNames(styles.button, styles.secondaryButton) }}
        onClick={showDataQualitySlideout}
      >
        {compactView ? <SettingOutlined className={styles.icon} /> : 'Settings'}
      </Button>
    </div>
  ) : (
    <></>
  );
};
